import { useAtom } from '@reatom/npm-react'
import { useMemo } from 'react'
import styled from 'styled-components'

import { Numeric } from '@blade/ui-kit'
import { balanceVisibleAtom } from '@root/entities/preferences'
import { Trend } from '@root/entities/trend'
import { PnlUsdFormatted } from '@root/shared/core/format'

import type { ClassNameProps } from '@root/shared/react'
import type BigNumber from 'bignumber.js'

export type DataEntry = [Date, BigNumber]

type Props = ClassNameProps & {
  change: BigNumber
  changePercentage: number
}

export const SummaryChartChange: React.FC<Props> = ({
  change,
  changePercentage,
  className,
}) => {
  const [isVisible] = useAtom(balanceVisibleAtom)

  const trend = Trend.of(changePercentage)

  const changeFormatted = useMemo(() => {
    if (change.isZero()) {
      return undefined
    }

    if (!isVisible) {
      return '*****'
    }

    return (
      <span>
        <PnlUsdFormatted pnl={change} />
        (<Numeric value={changePercentage} preset="percents" />
        %)
      </span>
    )
  }, [change, changePercentage, isVisible])

  return (
    <Root data-trend={trend} className={className}>
      {changeFormatted}
    </Root>
  )
}

const Root = styled.div`
  white-space: nowrap;
  font-weight: 700;
  font-size: 12px;
  &[data-trend='down'] {
    color: var(--down-9);
  }
  &[data-trend='neutral'] {
    color: var(--neutral-9);
  }
  &[data-trend='up'] {
    color: var(--up-9);
  }
`
